export default "__VITE_PUBLIC_ASSET__50dab5be__"